<input #input  class="form-control form-control-md" (keydown)="onKeyDown($event)" [(ngModel)]="value" appFractional />
